export default {
  none: `none`,
  default: `0 0 35px rgba(140,152,164,.125)`,
  lg: `0px 5px 25px rgba(28,33,54,.1)`,
  xl: `0 0.25rem 0.5rem rgb(0,0,0,0.05), 0 1.5rem 2.2rem rgb(0,0,0,0.1)`,
  primary: '0px 8px 40px 7px #0064AC1A, 0px 20px 50px 7px #0064AC14',
  gray: `0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814`,
};
